import { TemplateClass, templateTypeLabel } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';

const typeRequirements: Record<keyof typeof TemplateClass, string[]> = {
  Email: ['singleSend', 'smartSend', 'autoSend', 'drip'],
  PinpointEmail: ['singleSend', 'smartSend', 'autoSend', 'drip'],
  Page: ['landingPage'],
  Link: ['trackedLink'],
  ReferralBanner: ['invites'],
  ReferralEmail: ['invites'],
  ReferralPage: ['invites'],
  Banner: [],
  LandingPage: ['landingPage'],
};

export function getOptions(has: Record<string, boolean>): ISelectOption[] {
  return (
    Object.keys(TemplateClass)
      // Filter out account-level template options.
      .filter((key) => !['Email', 'Page', 'Link', 'Banner'].includes(key as TemplateClass))
      // Filter out templates that are not available with the given package.
      .filter((key) => {
        const requirements = typeRequirements[key as TemplateClass];
        if (!requirements) {
          return true;
        }
        return requirements.some((requirement) => has[requirement]);
      })
      .map<ISelectOption>((key) => {
        const value: TemplateClass = TemplateClass[key];
        return {
          id: value,
          name: templateTypeLabel(value),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name))
  );
}
